import './navbar.styles.scss';

export default angular.module('directives.abNavbar', [])
  .directive('abNavbar', () => {
    'ngInject';

    return {
      restrict: 'E',
      templateUrl: require('./navbar.template.html'),
    };
  })
  .name;
